import { render, staticRenderFns } from "./Supers.vue?vue&type=template&id=17774364&scoped=true&"
import script from "./Supers.vue?vue&type=script&lang=js&"
export * from "./Supers.vue?vue&type=script&lang=js&"
import style0 from "./Supers.vue?vue&type=style&index=0&id=17774364&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17774364",
  null
  
)

export default component.exports